export enum StepTypes {
  GENERIC,
  AUTHORS,
  FILES,
  LOCATIONS,
  RECIPIENTS,
  DOCS_TO_TRANSFER,
  LENTS,
  LOANS_HISTORY,
  BOUD
}